import { TrophyOutlined } from '@ant-design/icons';
import './ranking-card.css';
import { Card, Typography, Badge } from 'antd';
import { RatingDto } from '../../dto/reporting-models';
import { strings } from '../../lang';
const { Title, Text } = Typography;

const colors = ['var(--color-gold)', 'var(--color-silver)', 'var(--color-bronze)']; // Gold, Silver, Bronze

type RankingCardProps = {
  title: string;
  rankData: RatingDto | null;
};

const RankingCard = ({ title, rankData }: RankingCardProps) => {
  const getBadgeIcon = (index: number) => {
    if (index < 3) {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TrophyOutlined style={{ color: getBadgeColor(index), fontSize: '20px' }} />
        </div>
      );
    }
    return (
      <div style={{ display: 'flex' }}>
        <Badge count={index + 1} style={{ backgroundColor: 'var(--badge-bg)', color: 'var(--badge-text)', fontWeight: '600' }} />
      </div>
    );
  };

  const getRankingPositionBgColor = (position: number): string => {
    return colors[position - 1] || 'var(--rank-bg)';
  };

  const getBadgeColor = (index: number): string => {
    return colors[index] || 'var(--text-secondary)';
  };

  const getRankingTextColor = (position: number): string => {
    return position > 3 ? 'var(--color-white)' : position === 1 ? 'var(--text-primary)' : 'var(--bg-primary)';
  };

  return (
    <Card
      className="ranking-card"
      title={
        <Title level={5} style={{ marginLeft: '25px' }} ellipsis={{ tooltip: title }}>
          {title}
        </Title>
      }
    >
      <div className="callers-list">
        {rankData?.leaderboard?.slice(0, 5).map((item, index) => (
          <div key={index?.toString()} className="caller-item">
            <div style={{ marginLeft: '15px', display: 'flex', flex: 1, overflow: 'hidden' }}>
              {getBadgeIcon(index)}
              <Text strong style={{ marginLeft: '10px', marginRight: '20px', fontSize: '15px', flex: 1, overflow: 'hidden' }} ellipsis={{ tooltip: item.fullName }}>
                {item.fullName}
              </Text>
            </div>
            <Text style={{ marginRight: '20px' }}>{item.count}</Text>
          </div>
        ))}
        <div className="position-rank" style={{ backgroundColor: getRankingPositionBgColor(rankData?.currentUserPosition ?? 10), color: getRankingTextColor(rankData?.currentUserPosition ?? 10) }}>
          <div style={{ marginLeft: '15px', display: 'flex', flex: 1, overflow: 'hidden', padding: '2px' }}>
            <Badge
              count={rankData?.currentUserPosition}
              overflowCount={50}
              style={{ backgroundColor: 'var(--badge-primary-bg)', color: 'var(--badge-text)', fontWeight: '600', marginRight: '20px' }}
            />
            <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={strings.reportingYourPosition}>
              {strings.reportingYourPosition}
            </div>
          </div>
          <div style={{ marginRight: '20px' }}>{rankData?.currentUserCriteriaCount}</div>
        </div>
      </div>
    </Card>
  );
};

export default RankingCard;
